import { Box, Tooltip, Typography } from "@mui/material";
import { Fragment, useState } from "react";
import { useNavigate } from "react-router";
import ResourcesModal from "./ResourcesModal";

interface DashboardCardProps {
  count?: string,
  title?: string,
  description?: string,
  increasedBy?: string,
  path?: string,
  color?: string,
  endDate?: string,
  startDate?: string,
  type?: string[],
  allocationType?: string[],
  percentage?: any,
  tooltip?: boolean;
  tooltipDescription?: string;
}

const DashboardCard = (props: DashboardCardProps) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [utilized, setUtilized] = useState('');

  const handleOnClick = (path: string) => {
    if(path){
      navigate(path);
    }
    if(props?.description.includes('Underutilized by') || props?.description.includes('Overutilized by') || props?.count === '100%'){
      if(props?.description.includes('Underutilized by')){
        setUtilized('Underutilized');
      }
      if(props?.description.includes('Overutilized by')){
        setUtilized('Overutilized');
      }
      setOpen(true);
    }
  }

  const toggleOpen = () => {
    setOpen(!open);
  };

  return (
    <Fragment>
      <Tooltip disableHoverListener={props?.tooltip ? false : true} title={props?.tooltip && props?.tooltipDescription}>
        <Box p={2} sx={{ 
          backgroundColor: props?.color ? props?.color : 'white',
          cursor: (props?.path || props?.description.includes('Underutilized by') || props?.description.includes('Overutilized by') || props?.count === '100%') ? 'pointer' : 'unset',
          height: '100px',
          width: '100%', 
          borderRadius: 1,
          border: '1px solid rgba(0, 0, 0, 0.3);', 
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center'
        }}
        onClick={() => handleOnClick(props?.path)}>
          <Typography style={{ fontWeight: '500', fontSize: '12px' }}>{props?.title}</Typography>
          <Typography style={{ fontWeight: '700', fontSize: '20px' }}>{props?.count}</Typography>
          {props?.percentage && <Typography style={{ fontWeight: '600', fontSize: '15px' }}>{props?.percentage}</Typography>}
          <Typography 
            mt={1} 
            style={{ fontWeight: '500', fontSize: '12px', textAlign: 'center'}}>
            {props?.description}
            <span style={{ marginLeft: '5px', color: 'red' }}>{props?.increasedBy}</span>
          </Typography>
        </Box>
      </Tooltip>
      <ResourcesModal
        startDate={props?.startDate}
        endDate={props?.endDate}
        open={open}
        toggle={toggleOpen}
        type={props?.type}
        utilized={utilized}
        allocationType={props?.allocationType}
      />
    </Fragment>
  );
};

export default DashboardCard;
